import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toastWarning } from 'utils/toast';
import { DropsContext } from 'contexts/DropsContext';
import { GridContext } from 'contexts/GridContext';
import { PagamentosPendentesContext } from 'contexts/PagamentosPendentesContext';
import { useModal, useDialog } from 'components/Modals';
import ResumoModal from 'components/Modals/ResumoModal';
import Container from 'components/Container';
import Header from 'components/Header';
import Card from 'components/Card';
import Grid from 'components/Grid';
import AlteraçãoModal from '../Modals/AlteraçãoModal';
import Filter from './filter';
import mock from './mock';

const PagamentosPendentes = () => {
  const rotina = 'PagamentosPendentes';
  const titulo = 'Pagamentos Pendentes';
  const navigate = useNavigate();
  const { openModal } = useModal();
  const { openDialog } = useDialog();
  const { drops } = useContext(DropsContext);
  const { exportPdf, exportXls } = useContext(GridContext);
  const { pagamentosPendentes, getPagamentosPendentes, getLoading } =
    useContext(PagamentosPendentesContext);
  const { control, getValues, reset } = useForm({
    defaultValues: pagamentosPendentes?.filter,
  });

  const loadGrid = (props) => {
    if (props?.replace) {
      reset();
    }
    getPagamentosPendentes({ ...props, rotina, filter: getValues() });
  };

  const options = [
    {
      name: 'Exportar PDF',
      icon: 'file_download',
      action: () =>
        exportPdf({
          rotina,
          filter: getValues(),
          order: pagamentosPendentes?.order,
        }),
    },
    {
      name: 'Exportar XLS',
      icon: 'file_download',
      action: () =>
        exportXls({
          rotina,
          filter: getValues(),
          order: pagamentosPendentes?.order,
        }),
    },
    {
      name: 'Resumo',
      icon: 'summarize',
      action: () =>
        openModal(
          <ResumoModal
            colunas={pagamentosPendentes?.colunas}
            onSubmit={(group) =>
              navigate('/app/Resumo', {
                state: { rotina, group, filter: getValues() },
              })
            }
          />
        ),
    },
    {
      name: 'Baixar Pendências',
      icon: 'price_check',
      action: (pagamentos) => {
        if (!Boolean(pagamentos?.length)) {
          return toastWarning('Selecione ao menos um item');
        }

        if (new Set(pagamentos?.map((r) => r?.filial_id)).size > 1) {
          return toastWarning('Selecione apenas pendências da mesma filial');
        }

        navigate('/app/Pendencias/Baixa/Pagamentos', {
          state: { pagamentos },
        });
      },
    },
    {
      name: 'Alterar Dados',
      icon: 'edit',
      action: (financeiros) => {
        if (!Boolean(financeiros?.length)) {
          return toastWarning('Selecione ao menos um item');
        }
        openDialog(
          <AlteraçãoModal
            financeiros={financeiros}
            callback={loadGrid}
            modulo="COMPRAS"
          />,
          'Alterar Dados'
        );
      },
    },
  ];

  const rowOptions = [
    {
      name: 'Detalhes',
      icon: 'visibility',
      action: ({ row }) => navigate(`/app/Documento/${row?.documento_id}`),
    },
  ];

  return (
    <Container>
      <Header
        rotina={rotina}
        titulo={titulo}
        colunas={pagamentosPendentes?.colunas}
      />
      <Card>
        <Grid
          grid={pagamentosPendentes}
          mock={mock}
          options={options}
          rowOptions={rowOptions}
          control={control}
          checkboxSelection
          loading={getLoading}
          loadGrid={loadGrid}
          totalizer="valor_pendente"
          activeFilter={(getActiveFilter) => getActiveFilter(getValues())}
          FilterComponent={
            <Filter
              grid={pagamentosPendentes}
              control={control}
              drops={drops}
            />
          }
        />
      </Card>
    </Container>
  );
};

export default PagamentosPendentes;
